var helpers = {
	// variable: 'value' .... can get sile this self.variable
	init: function () {
		var self = this;
	},
	detectIE: function () {
		var e = window.navigator.userAgent;

		if (0 < e.indexOf('MSIE ')) return !0;

		if (0 < e.indexOf('Trident/')) {
			e.indexOf('rv:');
			return !0;
		}

		return 0 < e.indexOf('Edge/');
	},
	touch: function () {
		if (theme.globals.isTouch === true) {
			document.querySelector('html').classList.add('touch-device');
		} else {
			document.querySelector('html').classList.add('pointer-device');
		}
	},
	isJS: function () {
		(document.documentElement.className = document.documentElement.className.replace('no-js', 'js')), this.detectIE() && (document.documentElement.className = document.documentElement.className.replace('no-ie', 'is-ie'));
	},
};

export { helpers };
